import React from 'react';
import {
  NewThemeOverrider,
  FormButtonLayoutProps,
  FormLayoutProps,
  ErrorsWrapper,
} from 'ui-builder';
import styles from '../ChatWidget.module.scss';

function CompactSubmitButtonLayout(props: FormButtonLayoutProps) {
  return (
    <button
      type="button"
      className={styles.reportIssueSubmitBtn}
      onClick={props.onClick}
      disabled={props.isDisabled || props.isLoading}
      data-testid={props.testId}
    >
      {props.isLoading ? 'Submitting...' : props.text}
    </button>
  );
}

function CompactCancelButtonLayout(props: FormButtonLayoutProps) {
  return (
    <button
      type="button"
      className={styles.reportIssueCancelBtn}
      onClick={props.onClick}
    >
      {props.text}
    </button>
  );
}

function InChatFormLayout(props: FormLayoutProps) {
  return (
    <form
      data-testid={props.testID}
      className={`${styles.reportIssueForm} ${props.className || ''}`}
      autoComplete="nope"
      onSubmit={(e) => { e.preventDefault(); }}
    >
      <ErrorsWrapper name="__form">
        <div className="form-rows">
          {props.children}
        </div>
      </ErrorsWrapper>
      {props.buttons && (
        <div className="buttons">
          {props.buttons}
        </div>
      )}
    </form>
  );
}

const inChatFormTheme = {
  buttons: {
    SubmitButtonLayout: CompactSubmitButtonLayout,
    CancelButtonLayout: CompactCancelButtonLayout,
  },
  forms: {
    FormLayout: InChatFormLayout,
  },
};

export default function InChatFormTheme(props: { children: React.ReactNode }) {
  return (
    <NewThemeOverrider theme={inChatFormTheme}>
      {props.children}
    </NewThemeOverrider>
  );
}
